module.exports = __webpack_public_path__ + "static/media/cancel-service_4.85250ce7.png";